<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "download" });
export let css = "";
export let isScaling = true;
</script>

<svg xmlns = 'http://www.w3.org/2000/svg'
    fill = 'none'
    viewBox = '0 0 22 23'
    on:mouseenter
    on:mouseleave
    on:keypress
    on:click
    class = { `s8-icon ${ css }` }
    stroke = '#272711'
>
    <path
        d = 'M19.25 19.75H2.75M16.5 10.5833L11 16.0833M11 16.0833L5.5 10.5833M11 16.0833V3.25'
        stroke-width = '1.5'
        stroke-linecap = 'round'
        stroke-linejoin = 'round'
        vector-effect = { isScaling ? 'none' : 'non-scaling-stroke' }>
    </path>
</svg>